enum ConfigurationType {
  DEFAULT_PUBLIC_MESSAGE = 'default_public_message',
}

export default ConfigurationType
